import { froms } from './froms';
import { getFrom } from './getFrom';

/** 当前渠道信息 */
const from = getFrom();

export { from, froms };
export default {
  from,
  froms,
};
